/* eslint-disable no-unused-vars */
import DataTable from '@/containers/data_table_ml/DataTable';
import styles from './TablePage.less?modules';
import React, { useState, useEffect, useCallback } from 'react';
import { Form } from 'antd';
import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
import SelectML from '@/components/select_ml/SelectML';
import ButtonML from '@/components/button_ml/ButtonML';
import { useDispatch } from 'dva';
import { useUpdateEffect } from '@umijs/hooks';
import { message } from 'antd';
import { history } from 'umi';

const TablePage = (props) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [tableData, setTableData] = useState([]);
  const [datas, setDatas] = useState([]);
  const [options, setOptions] = useState([
    { name: '全部', value: null },
    { name: '规则包', value: 'RULE' },
    { name: '模型包', value: 'MODEL' },
  ]);
  const [nodeBlockTypeUse, setNodeBlockTypeUse] = useState(null);
  // const [nodeBlockNameUse, setNodeBlockNameUse] = useState('');
  const [selectedSingleDataUse, setSelectedSingleDataUse] = useState([]);
  const [params, setParams] = useState({});

  const onFinish = (values) => {
    setNodeBlockTypeUse(values.nodeBlockType);
    // setNodeBlockNameUse(values.nodeBlockName);
    setParams(values);
  };

  const refresh = (values) => {
    const str = values.nodeBlockName;
    let res = [];
    datas.forEach((item) => {
      if (str) {
        if (
          values.nodeBlockType &&
          item.nodeBlockType === nodeBlockTypeUse &&
          item.nodeBlockName.indexOf(str) > -1
        ) {
          res.push(item);
        } else if (
          !values.nodeBlockType &&
          item.nodeBlockName.indexOf(str) > -1
        ) {
          res.push(item);
        }
      }
      if (!str) {
        if (values.nodeBlockType && item.nodeBlockType === nodeBlockTypeUse) {
          res.push(item);
        } else if (!values.nodeBlockType) {
          res.push(item);
        }
      }
    });
    setTableData(res);
  };
  useUpdateEffect(() => {
    refresh(params);
  }, [params]);

  const submit = () => {
    if (selectedSingleDataUse.length > 0) {
      const {
        nodeBlock,
        nodeBlockType,
        nodeBlockName,
        description,
      } = selectedSingleDataUse[0]; // 只可能有一个 故取第一个
      const obj = { nodeBlock, nodeBlockType, nodeBlockName, description };
      props.addNodeEvent('ADDNODE', obj); // 将选择的通知给父组件
      props.handleCancel();
    } else {
      message.warn('请选择规则包/模型包');
    }
  };

  const reset = () => {
    form.resetFields();
    setTableData(datas);
    setNodeBlockTypeUse(null);
    // setNodeBlockNameUse('');
  };

  const columns = [
    {
      title: '包类名',
      dataIndex: 'nodeBlockType',
      key: 'nodeBlockType',
      width: 50,
      render: (record) => {
        return record === 'RULE'
          ? '规则包'
          : record === 'MODEL'
          ? '模型包'
          : '';
      },
    },
    {
      title: '规则/模型包名称',
      dataIndex: 'nodeBlockName',
      key: 'nodeBlockName',
      width: 50,
    },
    {
      title: '描述',
      dataIndex: 'description',
      key: 'description',
      width: 100,
    },
  ];
  // 选择
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      // 做复选框单选
      setSelectedSingleDataUse([selectedRowKeys[selectedRowKeys.length - 1]]);
    },
    onSelect: (record, selected, selectedRows) => {},
    onSelectAll: (selected, selectedRows, changeRows) => {
      const idArr = (selectedRows || []).map((item) => item.id);
    },
    // 设置复选框的值
    selectedRowKeys: selectedSingleDataUse,
    columnWidth: 40,
  };

  // const fetchData = useCallback(() => {
  //   dispatch({
  //     type: 'dgmp/queryNodeBlock',
  //     payload: {
  //       values: history.location.query.id,
  //     },
  //     callback: (data) => {
  //       if (data) {
  //         setTableData(data);
  //         setDatas(data);
  //       }
  //     },
  //   });
  // }, [dispatch]);

  // 发起请求
  useEffect(() => {
    // fetchData();
    setTableData(props.tableDataProps);
    setDatas(props.tableDataProps);
  }, [props.tableDataProps]);

  return (
    <div className={styles.addDiagramBox}>
      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        className={styles.serarchFrom}
      >
        <div className={styles.input_contain}>
          {/* 包类别 */}
          <SelectML
            height="37px"
            labelwidth="130px"
            labelVal="包类别"
            placeVal="请选择包类别"
            name="nodeBlockType"
            option={options}
          />
          {/* 包名称 */}
          <SingInputML
            height="37px"
            labelwidth="130px"
            inputWidth="160px"
            labelVal="包名称"
            placeVal="请输入包名称"
            name="nodeBlockName"
            allowClear={true}
          />
        </div>

        <div className={styles.btn_contain}>
          <ButtonML
            size="large"
            value="查询"
            htmlType="submit"
            fontsize="16px"
          />
        </div>
      </Form>
      <p className={styles.line}></p>
      <DataTable
        className="demo-test"
        style={{ minWidth: '800px' }}
        columns={columns}
        rowSelection={rowSelection}
        scroll={{ y: 'calc(70vh - 210px)' }}
        dataSource={tableData}
      />
      <div className={styles.btn_contain_update}>
        <ButtonML size="large" value="提交" onClick={submit} />
        <ButtonML size="large" value="重置" onClick={reset} />
      </div>
    </div>
  );
};
export default TablePage;
